import { Page } from '@desp-aas/desp-ui-fwk';
import Navigation from '../../components/Navigation/Navigation';
import { PrivacyPolicyContent } from './PrivacyPolicyContent';
import './PrivacyPolicyPage.css';


export const PrivacyPolicyPage = () => {
    return <Page id="gdpr-page">
        <Navigation />
        <PrivacyPolicyContent />
    </Page>
};
